<template>
  <div class="order-list" ref="listView" @scroll.passive="isReachBottom">
    <list-item
      v-for="(item, index) in list"
      :key="index"
      :infoTitle="item.infoTitle"
      :infoPic="item.infoPic"
      :orderId="item.orderId"
      :price="item.price"
      :createTime="item.createTime"
      :status="item.status"
      :selected="isSelected(item)"
      @click.native="choose(item)"
      class="list-item"
    ></list-item>
  </div>
</template>

<script>
import ListItem from '../ListItem'
import { isScrollToBottom, debounce } from '../../../../lib/utils'

export default {
  name: 'checkOrderList',
  props: ['list', 'curSelect'],
  data() {
    return {}
  },
  methods: {
    isSelected(item) {
      return this.curSelect.indexOf(item.orderId) > -1
    },
    choose(item) {
      this.$emit('select', item.orderId)
    },
    isReachBottom() {
      const listView = this.$refs.listView
      if (isScrollToBottom(listView)) {
        this.$emit('to-bottom')
      }
    }
  },
  mounted() {
    // 滚动函数防抖
    this.isReachBottom = debounce(this.isReachBottom, 100, false)
  },
  components: {
    ListItem
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
